
import React from 'react';
import { Progress } from '@/components/ui/progress';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Bike } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

interface BikeUsageProgressProps {
  used: number;
  total: number;
  loading?: boolean;
}

export const BikeUsageProgress: React.FC<BikeUsageProgressProps> = ({ 
  used, 
  total, 
  loading = false 
}) => {
  const percentage = total > 0 ? Math.round((used / total) * 100) : 0;
  const isMobile = useIsMobile();
  
  // Определим цвет индикатора в зависимости от загруженности
  const getIndicatorColor = () => {
    if (percentage > 80) return "bg-green-500"; // Высокая загрузка - хорошо
    if (percentage > 50) return "bg-amber-500"; // Средняя загрузка
    return "bg-blue-500";                       // Низкая загрузка
  };
  
  return (
    <Card className="bike-usage-card h-full">
      <CardHeader className="pb-2">
        <CardTitle className={`flex items-center ${isMobile ? 'text-base' : 'text-lg'}`}>
          <Bike className="h-5 w-5 mr-2 text-tuktuk-teal" />
          Загрузка парка велосипедов
        </CardTitle>
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="animate-pulse space-y-2">
            <div className="h-4 bg-muted rounded"></div>
            <div className="h-4 bg-muted rounded w-3/4"></div>
          </div>
        ) : (
          <>
            <Progress 
              value={percentage} 
              className="h-2 mt-2"
              indicatorClassName={getIndicatorColor()} 
            />
            <div className="flex justify-between items-center mt-2 text-sm">
              <span className="font-medium">{percentage}%</span>
              <span className={`text-muted-foreground ${isMobile ? 'text-xs' : 'text-sm'}`}>
                {used} из {total} в использовании
              </span>
            </div>
          </>
        )}
      </CardContent>
    </Card>
  );
};
